'use client';

import type { Dispatch, SetStateAction } from 'react';
import type { HandleChangeAnswerType } from '../model';
import type { AnswerUserType } from '~/model/AnswerUserType';
import { useLayoutEffect } from 'react';
import { createMedia } from '@/app/actions/server';
import { FileUploader } from '@/app/components/FileUploader/FileUploader';
import { getIdFromUri } from '@/app/utils/entities/uri';
import { apiPaths, apiTypes } from '~/const/api';
import { useFocus } from '~/hooks/useFocus';

export const UploadTypeQuestion = ({
  answerUser,
  questionId,
  handleChangeAnswer,
  handleLoading,
  type,
}: {
  answerUser: AnswerUserType;
  questionId: string;
  handleChangeAnswer: HandleChangeAnswerType;
  handleLoading: Dispatch<SetStateAction<boolean>>;
  type: string;
}) => {
  const [buttonRef, setButtonFocus] = useFocus();

  const { PICTURE } = apiTypes;

  const handleInputFileChange = async (fileToUpload: FormData) => {
    if (fileToUpload) {
      handleLoading(true);

      const data = await createMedia(fileToUpload);

      const mediaUri: string = data?.['@id'];
      const media: string = data?.content_url;

      if (data['hydra:description']) {
        handleLoading(false);
        return handleChangeAnswer(null, questionId, type);
      }

      handleChangeAnswer(mediaUri, questionId, type, null, null, media);
      handleLoading(false);
    } else {
      handleChangeAnswer(null, questionId, type);
    }
  };

  const defaultPicture = answerUser[questionId]?.media;

  useLayoutEffect(() => {
    setButtonFocus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonRef.current]);

  return (
    <FileUploader
      handleInputFileChange={handleInputFileChange}
      defaultFile={defaultPicture}
      id={`question-${getIdFromUri(questionId)}`}
      path={apiPaths.ANSWER}
      isPicture={type === PICTURE}
      fromQuestion
      buttonRef={buttonRef}
    />
  );
};
